export default __webpack_public_path__ + "media/zurb/img/playground/signal-blitz-homepage-b7dee06d286a43c7b07e625cc26f7d4c.png";